export default __webpack_public_path__ + "static/media/instruction-img-3.45d9aafd.png";